import React from "react";
import { Switch } from "react-router-dom";
import { PrivateRoute } from "../../components/privateRoute";
import ListFeatureToggles from './list/list-feature-toggles';
import EditFeatureToggle from "./update/edit";

const FeatureToggleRoutes = ({setBorehole}: any) => {
  return (    
    <Switch>      
      <PrivateRoute exact path="/admin/feature-toggles/list">
        <ListFeatureToggles setBorehole={setBorehole} />        
      </PrivateRoute>
      <PrivateRoute exact path="/admin/feature-toggles/:featureToggleId">
        <EditFeatureToggle setBorehole={setBorehole} />        
      </PrivateRoute>
    </Switch>            
  );
};

export default FeatureToggleRoutes;
